import NetworkSpeedConverter from "./NetworkSpeedConverter";

export default NetworkSpeedConverter;